export interface IConversationsCapabilityConfigurationObject {
  isMobile: boolean;
  navIconTheme: string;
  isConnectEnabled: boolean;
  isNeiEnabled?: boolean;
}

export class ConversationsCapabilityConfiguration {
  private _config: IConversationsCapabilityConfigurationObject;

  constructor() {
    this._config = {
      isMobile: false,
      navIconTheme: 'blue',
      isConnectEnabled: false,
      isNeiEnabled: false
    };
  }

  get config(): IConversationsCapabilityConfigurationObject {
    return this._config;
  }

  set config(configs: IConversationsCapabilityConfigurationObject) {
    this._config = { ...this._config, ...configs };
  }

  setConfig(key: string, value: any): void {
    this._config[key] = value;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/configuration.ts